<template>
  <div class="wrap">
    <!-- browser-suggestion -->
    <browser-suggestion></browser-suggestion>
    <!-- browser-suggestion -->

    <div class="wrapper">
      <div class="form-title-wrap">
        <form-title :tip="tip" :tip3="tip3" :flag="flag"></form-title>
      </div>

      <div class="operate-btn">
        <!-- <el-button
          type="primary"
          style="background: #01539f"
          @click="applyPost"
          v-show="applyPostShow"
        >
          申请职位
        </el-button> -->
        <el-button type="warning" @click="addNewResume">新增简历</el-button>
      </div>

      <div class="resume-list">
        <ul>
          <li v-for="(item, index) in resumeList" :key="index">
            <div>
              <h1
                style="
                  margin-bottom: 15px;
                  display: flex;
                  height: 18px;
                  align-items: center;
                "
              >
                <!-- <el-checkbox-group
                  @change="changeCheckBox"
                  :min="0"
                  :max="1"
                  v-model="checkList"
                >
                  <el-checkbox :label="item.soid">
                    {{ item.resumename }}
                  </el-checkbox> -->
                <!-- </el-checkbox-group> -->
                <span class="font-css" style="margin-left: 24px">
                  {{ item.resumename }}
                </span>
                <span class="font-css" style="margin-left: 10px">
                  {{ item.createtime }}
                </span>
              </h1>
              <div>
                <span style="margin-left: 25px">
                  <span class="font-css">完成度</span>
                  <el-progress
                    class="inlineCSS"
                    :percentage="item.resumecompl"
                    :color="customColorMethod(item.resumecompl)"
                  />
                </span>
                <span
                  style="
                    margin-left: 125px;
                    width: 408px;
                    display: inline-block;
                  "
                >
                  <span class="font-css" style="margin-right: 30px">
                    创建时间-{{ item.createtime }}
                  </span>
                  <span class="font-css">编辑时间-{{ item.modifytime }}</span>
                </span>
                <span
                  style="margin-left: 50px; width: 350px; display: inline-block"
                >
                  <span
                    class="font-css"
                    @click="goEdit(item.oid, item.soid)"
                    style="margin-right: 30px; cursor: pointer"
                  >
                    <i class="el-icon-edit" />
                    编辑
                  </span>
                  <span
                    class="font-css"
                    @click="goView(item.oid, item.soid)"
                    style="cursor: pointer; margin-right: 30px"
                  >
                    <i class="el-icon-view" />
                    预览
                  </span>
                  <span
                    class="font-css"
                    style="cursor: pointer; margin-right: 30px"
                    @click="del(item.soid)"
                  >
                    <i class="el-icon-delete" />
                    删除
                  </span>
                  <span
                    class="font-css"
                    style="cursor: pointer"
                    @click="exp(item.soid)"
                  >
                    <i class="el-icon-printer" />
                    导出
                  </span>
                </span>
              </div>
            </div>
            <el-divider></el-divider>
          </li>
        </ul>
      </div>

      <!-- <div class="dialog">
        <el-dialog
          title="职位申请"
          :visible.sync="dialogVisible"
          width="540px"
          center
          close-on-click-modal
          :show-close="false"
          :modal-append-to-body="false"
        >
          <div class="diglog-content">
            <div class="orgname">
              <span>岗位已投递人数:</span>
              {{ totalPsn }}
            </div>
            <div class="orgname">
              <span>应聘单位:</span>
              {{ resumeSelectData.orgname }}
            </div>
            <div class="postname">
              <span>应聘职位:</span>
              {{ resumeSelectData.postname }}
            </div>

            <div class="tips-su">-->
              <!-- <p>说明 : 岗位一旦投递，将不能进行撤回操作，请确认</p> -->
              <!-- <p>请选择职位， 点击“申请”按钮进行投递</p> -->
              <!-- <p>注意事项：</p>
              <p>
                1.同一家单位只能投递一个岗位，不能重复投递，请仔细核对要投递的单位和职位信息；
              </p>
              <p>
                2.简历一经投递，无法对投递的内容进行修改，修改简历信息将在下次投递时生效；
              </p>
              <p>3.核对无误后，请点击确认按钮。</p>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button
              style="background: #01539f"
              type="primary"
              @click="confirmSend"
            >
              确认投递
            </el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
          </span>
        </el-dialog>
      </div> -->
    </div>
  </div>
</template>

<script>
import formTitle from "../common/formTitle";
import { myResume, delResume, exportResume } from "../request/resumeApi";
import { dictData, sendmyResume, queryTotalPsn } from "../request/api";
import { MessageBox, Message } from "element-ui";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "resumeList",
  components: {
    formTitle,
  },
  data() {
    return {
      // 全局返回路由
      globalBackRoute: {},

      // 申请按钮是否显示
      // applyPostShow: false,

      checkList: [],
      getNowTime: "",
      flag: false,
      tip: "我的简历",
      tip3: '温馨提示:建议达到100%进行投递。如未达到,请点击"编辑"进行完善',
      dialogVisible: false,
      resumeList: [],
      // 公司
      orgList: [],
      dictList: [],
      commoneduList: [],
      // totalPsn: 0,
      // SelectData: {
      //   postoid:'',
      //   postname:'',
      //   orgname:''
      // }
    };
  },
  methods: {
    ...mapMutations([
      "pushBackRoute",
      // 设置全局选中数据
      "setResumeSelectData",
    ]),
    ...mapActions(["popBackRoute"]),
    dictData(type, list) {
      let data = {
        type: type,
      };
      dictData(data).then((response) => {
        this[list] = response.data;
      });
    },
    // 初始化选择的数据
    initSelectData() {
      // applyPostShow
      if (!this.$route.query.postoid || this.$route.query.postoid == "") {
        return;
      }

      // 设置全局路由
      this.setResumeSelectData({
        oid: `${this.$route.query.postoid}`,
        postoid: `${this.$route.query.postoid}`,
        postname: window.decodeURI(`${this.$route.query.postname}`),
        orgname: window.decodeURI(`${this.$route.query.orgname}`),
      });
    },
    //编辑
    goEdit(oid, soid) {
      var route = {
        back: {
          path: "/resumeList",
          // query: {
          //   ...this.SelectData
          // }
        },
        forward: {
          path: "/personInfo",
          query: {
            oid: oid,
            soid: soid,
            VOStatus: "edit",
          },
        },
      };
      this.$store.commit("pushBackRoute", route.back);
      this.$router.push(route.forward);
    },
    //预览
    goView(oid, soid) {
      // this.$router.push('/resumeView?soid=' + soid)
      var route = {
        back: {
          path: "/resumeList",
          // query: {
          //   ...this.SelectData
          // }
        },
        forward: {
          path: "/personInfo",
          query: {
            oid: oid,
            soid: soid,
            VOStatus: "view",
          },
        },
      };
      this.$store.commit("pushBackRoute", route.back);
      this.$router.push(route.forward);
    },
    //删除
    del(soid) {
      let params = {
        soid: soid,
      };

      MessageBox.confirm("确认要删除此简历吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          delResume(params).then((res) => {
            // console.log(res)
            if (res.code == "1") {
              Message({
                type: "success",
                message: "删除成功",
              });
              this.getResume();
            }
          });
        })
        .catch(() => {
          Message({
            type: "info",
            message: "取消操作",
          });
        });
    },

    // 导出
    exp(soid) {
      let params = {
        soid: soid,
        formKey: "MyResumeLib",
        dataObjectKey: "MyResumeLib",
        reportKey: "MyResumeLibInfoPrint",
      };

      exportResume(params).then((res) => {
        let fileName = this.guid() + ".pdf";
        const blob = new Blob([res]);
        if (window.navigator.msSaveBlob) {
          window.navigator.msSaveBlob(blob, fileName);
        } else {
          var a = document.createElement("a");
          var URL = window.URL || window.webkitURL;
          var u = URL.createObjectURL(blob);
          a.href = u;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(u);
        }
        this.getResume();
      });
    },
    guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },

    //新增简历
    addNewResume() {
      var route = {
        back: { path: "/resumeList" },
        forward: { path: "/personInfo?VOStatus=new" },
      };
      this.$store.commit("pushBackRoute", route.back);
      this.$router.push(route.forward);
    },
    //进度条颜色
    customColorMethod(percentage) {
      if (percentage < 100) {
        return "#f25727";
      } else {
        return "#61b548";
      }
    },
    //我的简历列表
    getResume() {
      let params = {};
      myResume(params).then((res) => {
        // console.log(res.data)
        if (res.code == "1") {
          this.resumeList = res.data;
        }
        // console.log(this.resumeList);
      });
    },
    //复选框选中
    changeCheckBox(val) {
      this.checkList = val;
    },
    //申请职位
    // applyPost() {
    //   if (this.checkList.length == 0) {
    //     this.$message({
    //       message: "请选择一个简历进行投递",
    //       type: "warning",
    //     });
    //   } else {
    //     this.getTotalPsn();
    //     this.dialogVisible = true;
    //   }
    // },
    //根据发布岗位id获取发布中的公告然后查询投递人数
    // getTotalPsn() {
    //   let data = {
    //     postoid: this.$route.query.postoid,
    //   };
    //   queryTotalPsn(data).then((response) => {
    //      this.totalPsn = response.data;
    //   });
    // },
    //确认投递
    // confirmSend() {
    //   if (this.resumeSelectData.postoid == "") {
    //     this.$message({
    //       message: "请选择一个岗位!",
    //       type: "warning",
    //     });
    //     return;
    //   }

    //   if (this.checkList.length == 0) {
    //     this.$message({
    //       message: "请选择一个简历进行投递",
    //       type: "warning",
    //     });
    //     return;
    //   }

    //   // 必须显示才能点击
    //   if (!this.dialogVisible) {
    //     return;
    //   }
    //   this.dialogVisible = false;

    //   // resolve
    //   this.checkList.forEach((soid) => {
    //     var params = {
    //       soid,
    //       postoid: this.resumeSelectData.postoid,
    //     };

    //     // 投递
    //     sendmyResume(params).then((res) => {
    //       console.log(res);
    //       if (!res.success) {
    //         this.$message({
    //           message: res.message,
    //           type: "warning",
    //         });
    //         return;
    //       } else {
    //         this.$message({
    //           message: `投递成功`,
    //           type: "info",
    //         });
    //       }
    //     });
    //   });
    // },
  },
  mounted() {
    this.initSelectData();

    this.getResume();

    // 消费全局路由
    this.popBackRoute().then((res) => {
      this.globalBackRoute = res;
    });

    // this.dictData('org_post', 'dictList')
    // this.dictData('org_orgs', 'orgList')

    // 根据岗位ID查询公司
  },
  computed: {
    ...mapState(["resumeSelectData"]),
    // 是否显示申请按钮
    applyPostShow() {
      if (this.resumeSelectData && this.resumeSelectData.postoid) {
        return true;
      }
      // if(this.$store.state.resumeSelectData
      //   && this.$store.state.resumeSelectData.postoid) {
      //   return true;
      // }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: auto;

  .wrapper {
    width: 1280px;
    margin: 0 auto;
    // margin-top: 100px;
    // margin-bottom: 200px;

    .operate-btn {
      margin-bottom: 12px;

      .el-button {
        border-radius: 0;
        border: none;
        margin-left: 0;
        margin-right: 12px;
      }
    }

    .form-title-wrap {
      line-height: 40px;
      margin-bottom: 12px;
      background: #fff;
      border-radius: 4px;
      padding-left: 12px;
      padding-right: 12px;
    }

    .resume-list {
      // border: 1px solid black;
      // width: 69%;
      // margin: 0 auto;
      background: #fff;
      padding: 12px;
      margin-bottom: 12px;
      min-height: 400px;

      .font-css {
        font-size: 13px;
        color: #8c8c8c;
      }
    }
    .dialog {
      ::v-deep .diglog-content {
        height: 245px;
        color: rgba(0, 0, 0, 0.85);

        .orgname {
          height: 40px;
          line-height: 40px;
          font-size: 18px;

          // 超出省略号
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .postname {
          height: 40px;
          line-height: 40px;
          font-size: 18px;

          // 超出省略号
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .tips-su {
          // height: 40px;
          line-height: 40px;
          font-size: 12px;
          color: rgba(255, 0, 0, 0.6);

          p {
            margin: 0px;
          }
        }
      }

      ::v-deep .el-dialog__header {
        background: #01539f;
      }

      ::v-deep .el-dialog__title {
        color: white;
      }
    }
  }
}
::v-deep .el-progress-bar {
  width: 20%;
}
::v-deep .inlineCSS {
  display: inline;
  margin-left: 10px;
}
</style>
